export const BASE_URL = process.env.NODE_ENV === "production" ?
    'https://api-admin.bitzsoftwares.com.br' :
    'http://localhost:3338';